import "./styles.scss";

import classnames from "classnames";
import { useTranslation } from "react-i18next";

import Switch from "components/form/Switch";

const mainClass =
  "new-website-content__choose-plan__subscription-plan__header__item__billed-switcher";

const BilledSwitcher = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className={mainClass}>
      <span className={classnames({ active: value === "monthly" })}>
        <label>{t("Monthly")}</label>
        <small>{t("billed monthly")}</small>
      </span>
      <Switch
        checked={value === "yearly"}
        onChange={() => onChange(value === "monthly" ? "yearly" : "monthly")}
      />
      <span className={classnames({ active: value === "yearly" })}>
        <label>{t("Yearly")}</label>
        <small>{t("billed monthly")}</small>
      </span>
    </div>
  );
};

export default BilledSwitcher;